import STBoardComments from "../../../assets/styles/organisms/boardComment.module.scss";
import ReplyOutlinedIcon from "@material-ui/icons/ReplyOutlined";
import { useContext, useState, useRef, useEffect } from "react";
import { ContentCommentField } from "./CommentForm";
import { LoginUserContext } from "../../../providers/LoginUserProvider";
import { TAppMember } from "../../../types/TAppMember";
import CommentActions from "./CommentActions";
import { PiPushPinFill } from "react-icons/pi";
import Avatar from "../../atoms/Avatar";
import LikeButton from "../../molecules/LikeButton";
import { useBoard } from "../../../providers/BoardDetailProvider";
import { COMMENT_LIKE_TYPE } from "../../../utils/boardDetailConstants";
import MessageBoardNickname from "../../atoms/MessageBoardNickname";
import { getFormatDateTimeDefault } from "../../../utils/getFormatDateTimeDefault";
import ImageSlider from "../../molecules/ImageSlider";
import LinkifyText from "../../molecules/LinkifyText";

type CommentProps = {
  data: any;
  isRoot: boolean;
};

const Comment = (props: CommentProps) => {
  const [isReply, setIsReply] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const replyInputRef = useRef<HTMLDivElement>(null);
  const { data, isRoot } = props;
  const {
    content,
    image_urls = [],
    total_of_likes,
    avatar_url,
    nickname,
    created_at,
    id,
    parent_id,
    is_pinned,
    like_flg = 0,
    uid,
  } = data;
  const currentUser = useContext(LoginUserContext);
  const { member = {} } = currentUser ?? {};
  const { avatar_url: currentUserAvatarUrl = "" } = member as TAppMember;

  const { updateLikedCommentStatus } = useBoard();

  const onToggleReplyInput = () => {
    setIsReply((pre) => !pre);
  };
  const onToggleEditForm = () => {
    setIsEdit((pre) => !pre);
  };

  const onCloseForm = () => {
    setIsEdit(false);
    setIsReply(false);
  };

  const onLikeCommentSuccess = () => {
    updateLikedCommentStatus(parent_id, id, Number(!like_flg), true);
  };

  useEffect(() => {
    if (isReply && replyInputRef.current) {
      replyInputRef.current.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'nearest' 
      });
    }
  }, [isReply]);

  return (
    <div className={STBoardComments.newCommentContainer}>
      <div
        className={`${STBoardComments.newCommentElement} ${STBoardComments.newChildrenCommentElement}`}
      >
        <div className={STBoardComments.newCommentElementAvatar}>
          <Avatar avatarUrl={avatar_url} className={STBoardComments.avatar} />
        </div>
        <div className={STBoardComments.newCommentInformation}>
          <div className={STBoardComments.newCommentHeader}>
            <div>
              <div className={STBoardComments.newCommentHeaderNickname}>
                <MessageBoardNickname
                  component="p"
                  uid={uid}
                  nickname={nickname}
                />
                {!!is_pinned && <PiPushPinFill />}
              </div>
              <p className={STBoardComments.newCommentHeaderCreatedAt}>
                {getFormatDateTimeDefault(created_at)}
              </p>
            </div>
            <CommentActions
              authorId={uid}
              isPinned={is_pinned}
              parentId={parent_id}
              commentId={id}
              onToggleCommentForm={onToggleEditForm}
            />
          </div>
          <div className={STBoardComments.newCommentBody}>
            {isEdit ? (
              <ContentCommentField
                commentId={id}
                imageUrls={image_urls}
                defaultValue={content}
                isEdit={isEdit}
                parentId={parent_id}
                onToggleEditForm={onToggleEditForm}
                onCloseForm={onCloseForm}
              />
            ) : (
                <div className={STBoardComments.commentBody}>
                  {image_urls?.length > 0 && <ImageSlider className={STBoardComments} imageUrls={image_urls} />}
                  <LinkifyText text={content} className={STBoardComments.contentCommentDisplay} />
                </div>
            )}
          </div>
          <div className={STBoardComments.newCommentFooter}>
            <LikeButton
              key={id}
              rootId={id}
              likeFlg={Number(!!like_flg)}
              likeType={COMMENT_LIKE_TYPE}
              totalOfLikes={total_of_likes}
              className={STBoardComments.newCommentFooterLikes}
              onSuccess={onLikeCommentSuccess}
            />
            {isRoot && (
              <div
                className={STBoardComments.newCommentFooterComments}
                onClick={onToggleReplyInput}
              >
                <ReplyOutlinedIcon fontSize="inherit" />
                <span>返信</span>
              </div>
            )}
          </div>
          {isReply && (
            <div 
              ref={replyInputRef}
              className={STBoardComments.newCommentFooterReplyComments}
            >
              <Avatar
                avatarUrl={currentUserAvatarUrl}
                className={STBoardComments.avatar}
              />
              <ContentCommentField
                parentId={id}
                onToggleEditForm={onToggleEditForm}
                onCloseForm={onCloseForm}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Comment;
